import { render, staticRenderFns } from "./weightRepInput.vue?vue&type=template&id=63e17fb5&scoped=true"
import script from "./weightRepInput.vue?vue&type=script&lang=js"
export * from "./weightRepInput.vue?vue&type=script&lang=js"
import style0 from "./weightRepInput.vue?vue&type=style&index=0&id=63e17fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e17fb5",
  null
  
)

export default component.exports